<script setup lang="ts">
import { IChatSendField, IChatMessage } from '../i'
import { getSupportChat } from '@caks/shared/api/user.route'
import { GroupedMessage } from '@caks/shared/types/types.api'
import { ref, onMounted, onUnmounted } from 'vue'
import { groupMessages, formatGroupDate } from '@caks/shared/utils/chatHelpers'

interface Props {
  desktop?: boolean
}

withDefaults(defineProps<Props>(), { desktop: false })

const chat = ref<Array<GroupedMessage>>([])
let chatInterval: ReturnType<typeof setInterval>

onMounted(async () => {
  updateChat()
  chatInterval = setInterval(() => updateChat(), 5000)
})
onUnmounted(() => {
  clearInterval(chatInterval)
})

const updateChat = async (onSend?: boolean) => {
  try {
    const res = await getSupportChat()
    if (res.status === 'ERR') throw res.message
    chat.value = groupMessages(res.data)

    if (onSend) {
      console.log(messageContainer.value?.scrollTop)

      nextTick(() => {
        messageContainer.value?.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
      })
    }
  } catch (error) {
    console.error(error)
  }
}

const messageContainer = ref<HTMLElement>()
</script>

<template>
  <div class="chat" :class="{ chat_desktop: desktop }">
    <div class="chat__background"></div>
    <div class="chat__messages" ref="messageContainer">
      <ul v-for="group in chat" :key="group.id" class="message-group">
        <div class="message-group__date">{{ formatGroupDate(group.date) }}</div>
        <li v-for="message in group.messages" :key="message.id">
          <i-chat-message :message="message" :desktop="desktop" />
        </li>
      </ul>
    </div>
    <i-chat-send-field @send="updateChat" :desktop="desktop" />
  </div>
</template>

<style scoped lang="scss">
.chat {
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  justify-content: flex-end;
  height: calc(var(--viewport-height) - 40px - env(safe-area-inset-bottom) - env(safe-area-inset-top));
  border-top-right-radius: 16px;
  border-top-left-radius: 16px;
  padding: 8px 0 60px 0;
  background: #fafafa;


  &__background {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    background: $bg-gray url('/assets/images/chat/chat-bg.png') no-repeat top;
    background-size: cover;

    .chat_desktop & {
      height: 720px;
      width: 100%;
      position: absolute;
      z-index: -1;
    }
  }

  &_desktop {
    height: calc(100% - 36px);
    width: 100%;
    border-radius: 0;
  }

  &__messages {
    display: flex;
    flex-direction: column-reverse;
    width: 100%;
    height: calc(var(--viewport-height) - 20px);
    overflow-y: scroll;
    position: relative;

    .message-group {
      @include h5-6;
      color: $sub-text;
      display: flex;
      flex-direction: column;
      gap: 8px;

      &__date {
        padding: 8px 12px;
        border-radius: 10px;
        background-color: $sub-green;
        width: fit-content;
        margin: 32px auto;
      }
    }
  }
}
</style>
